import React, { useEffect, useRef, useState } from "react";
import { ABtn, AScore, AResult } from "./arcadeUi";
import { sfx } from "@/lib/soundfx";

const W = 300, H = 300;

export default function DuckShoot() {
  const canvasRef = useRef(null);
  const g = useRef({});
  const scoreRef = useRef(0);
  const [score, setScore] = useState(0);
  const [lives, setLives] = useState(3);
  const livesRef = useRef(3);
  const [status, setStatus] = useState("idle");

  const start = () => { g.current = { ducks: [], spawn: 0, speed: 1.6 }; scoreRef.current = 0; setScore(0); livesRef.current = 3; setLives(3); setStatus("playing"); sfx.beep(); };

  useEffect(() => {
    const ctx = canvasRef.current.getContext("2d");
    const cvs = canvasRef.current;
    const shoot = (e) => {
      if (status !== "playing") return;
      const r = cvs.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width * W, y = (e.clientY - r.top) / r.height * H;
      const s = g.current; sfx.shoot();
      for (const d of s.ducks) { if (!d.dead && Math.abs(d.x - x) < 20 && Math.abs(d.y - y) < 18) { d.dead = true; d.vy = 3; scoreRef.current += 10; setScore(scoreRef.current); sfx.hit(); break; } }
    };
    cvs.addEventListener("pointerdown", shoot);
    const draw = () => {
      ctx.fillStyle = "#87ceeb"; ctx.fillRect(0, 0, W, H);
      ctx.fillStyle = "#5aa02c"; ctx.fillRect(0, H - 40, W, 40);
      ctx.fillStyle = "#fff"; ctx.beginPath(); ctx.arc(60, 50, 16, 0, 7); ctx.arc(80, 50, 20, 0, 7); ctx.fill();
      const s = g.current;
      (s.ducks || []).forEach((d) => {
        ctx.fillStyle = d.dead ? "#7c3f00" : "#3b3b3b";
        ctx.fillRect(d.x - 12, d.y - 8, 24, 14);
        ctx.fillStyle = "#e8b04b"; ctx.fillRect(d.x + (d.vx > 0 ? 10 : -14), d.y - 4, 6, 5);
        ctx.fillStyle = d.dead ? "#7c3f00" : "#fff"; ctx.fillRect(d.x - 4, d.y - 14 + (Math.sin(Date.now() / 90 + d.x) * 3), 8, 8);
      });
    };
    if (status !== "playing") { draw(); return () => cvs.removeEventListener("pointerdown", shoot); }
    let raf;
    const loop = () => {
      raf = requestAnimationFrame(loop);
      const s = g.current;
      s.spawn--;
      if (s.spawn <= 0) { s.spawn = 70 + (Math.random() * 40 | 0); const fromLeft = Math.random() > 0.5; s.ducks.push({ x: fromLeft ? -14 : W + 14, y: 40 + Math.random() * (H - 120), vx: (fromLeft ? 1 : -1) * (s.speed + Math.random()), vy: 0, dead: false }); }
      for (const d of s.ducks) { if (d.dead) { d.vy += 0.4; d.y += d.vy; } else { d.x += d.vx; } }
      // ducks that escaped
      const before = s.ducks.length;
      s.ducks = s.ducks.filter((d) => {
        if (d.dead) return d.y < H + 20;
        if (d.x < -20 || d.x > W + 20) { livesRef.current -= 1; setLives(livesRef.current); sfx.lose(); return false; }
        return true;
      });
      if (livesRef.current <= 0) { cancelAnimationFrame(raf); sfx.explode(); setStatus("over"); return; }
      s.speed = 1.6 + scoreRef.current / 150;
      draw();
    };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); cvs.removeEventListener("pointerdown", shoot); };
  }, [status]);

  return (
    <div className="flex flex-col items-center">
      <div className="mb-2 flex gap-2"><AScore label="Score" value={score} /><AScore label="Lives" value={"❤".repeat(lives) || "0"} /></div>
      <div className="relative">
        <canvas ref={canvasRef} width={W} height={H} className="w-full max-w-[280px] cursor-crosshair rounded-md border-[3px] border-kirana-brown" style={{ imageRendering: "pixelated", touchAction: "none" }} />
        {status !== "playing" && (
          <div className="absolute inset-0 flex flex-col items-center justify-center rounded-md bg-black/60 p-2">
            {status === "over" && <AResult win={false} text={`Score · ${score}`} testId="duck-over" />}
            <ABtn tone="green" onClick={start} className="mt-3">{status === "idle" ? "Start" : "Play Again"}</ABtn>
          </div>
        )}
      </div>
      <p className="mt-2 text-center text-xs text-kirana-cream/70">Tap the ducks to shoot 🦆</p>
    </div>
  );
}
